import Axios from "axios";

const state = () => ({
  user: {},
  info: {},
  code: null,
  message: null,
  status: null,
  loading: false,
  host: process.env.VUE_APP_API_HOST || 'http://localhost:8020',
});

const mutations = {
  set_user(state, user){
    state.user = user
  },
  set_info(state, info){
    state.info = info
  },
  set_code(state, code){
    state.code = code
  },
  set_message(state, message){
    state.message = message
  },
  set_status(state, status){
    state.status = status
  },
  set_loading(state, loading){
    state.loading = loading
  }
};

const actions = {
  get_user({ commit, state }) {
    return new Promise((resolve, reject) => {
      commit("set_loading", true);

      let url = state.host+"/sdm/employee";
      let headers = { Authorization: "Bearer " + localStorage.getItem("token") };
      
      Axios.get(url, { headers: headers })
        .then((response) => {
          const user = response.data || {};

          commit("set_loading", false);
          commit("set_user", user);
          resolve(response);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            localStorage.removeItem("token");
            delete Axios.defaults.headers.common["Authorization"];
            this.$router.push({ name: "home" });
          }
          commit('set_message', error.response.data.error_description)
          commit("set_loading", false);
          reject(error);
        });
    });
  },
  async fetchUserRole({ commit, state }, payload) {
    commit('set_loading', true);

    let url = state.host+"/api/roles/users?page=" + payload.page + "&size=" + payload.size;

    if (payload.search.username) {
      url += "&username=" + encodeURIComponent(payload.search.username);
    }

    if (payload.search.rolename) {
      url += "&role=" + encodeURIComponent(payload.search.rolename);
    }

    // if (payload.search.username && payload.search.rolename) {
    //   url += "&username=" + encodeURIComponent(payload.search.username) + "&role=" + encodeURIComponent(payload.search.rolename);
    // }

    const headers = { Authorization: "Bearer " + payload.token, 'Content-Type': 'application/json' };

    try {
      const response = await Axios.get(url, { headers: headers });

      commit('set_user', response.data.data);
      commit('set_info', response.data.info);
      commit('set_code', response.data.code);
      commit('set_message', response.data.message);
      commit('set_status', response.status);
    } catch (error) {
      commit('set_code', error.response ? error.response.data.code : null);
      commit('set_message', error.response ? error.response.data.message : error.message);
      commit('set_status', error.response ? error.response.status : null);
    } finally {
      commit('set_loading', false);
    }
  },
  async updateUserRole({ commit, state }, payload) {
    commit('set_loading', true);

    const url = `${state.host}/api/roles/users/${payload.userId}/roles`;
    const headers = { 
      Authorization: "Bearer " + payload.token, 
      'Content-Type': 'application/json' 
    };
    const data = {
      roles: payload.roles
    };

    try {
      const response = await Axios.put(url, data, { headers: headers });

      commit('set_code', response.data.code);
      commit('set_message', response.data.message || 'Role berhasil diupdate');
      commit('set_status', response.status);
      commit('set_loading', false);
      
      return {
        message: response.data.message || 'Role berhasil diupdate',
        data: response.data
      };
    } catch (error) {
      commit('set_code', error.response ? error.response.data.code : null);
      commit('set_message', error.response ? error.response.data.message : error.message);
      commit('set_status', error.response ? error.response.status : null);
      commit('set_loading', false);
      
      throw new Error(error.response ? error.response.data.message : error.message);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};